import { init } from '@amplitude/analytics-browser'

const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE

export const initAmplitude = () => {
  if (AMPLITUDE_KEY) {
    init(AMPLITUDE_KEY)
  }
}
